<cb-dialog dialogHeading="Qualify Lead">
    <form class="flex-row flex" #leadQualifyHouseLandForm="ngForm">
        <div class="cb-margin-right-3x flex-col flex">
            <h1 class="cb-margin-bottom-2x mat-headline-6">
                Qualify Lead - House &amp; Land / Design &amp; Land
            </h1>
            <div class="cb-margin-bottom-2x start-center flex-row">
                <mat-icon class="mat-accent"> info </mat-icon>
                <span class="mat-body-2 cb-margin-left">
                    Search for an existing Client Account to qualify this Lead against. Create a new
                    Client Account if there is no existing Account
                </span>
            </div>
            <span class="mat-body-strong">Search or Create a new Client Account</span>
            @if (!data.createNewClientAccount) {
                <cb-client-accounts-input-find-cards
                    label="Select Existing Client Account"
                    [(ngModel)]="selectedAccount"
                    name="selectedAccount"
                    [text]="selectedAccount?.name"
                    [removeable]="true"
                    [required]="!data.createNewClientAccount"
                    #selectedAccountControl="ngModel"
                    (change)="selectedAccountChanged()"
                >
                </cb-client-accounts-input-find-cards>
            }
            <cb-checkbox
                label="Create New Client Account"
                name="createNewClientAccount"
                (change)="createClientAccountChange()"
                [(ngModel)]="data.createNewClientAccount"
            >
            </cb-checkbox>
        </div>
        <mat-divider></mat-divider>
        <div class="flex-col flex">
            <span class="mat-body-strong cb-margin-bottom-2x"
                >Choose the Lots to Convert to a Client Sale</span
            >
            @for (
                interest of mappedItem.interests | cbCallback: filterInterests;
                track interest;
                let last = $last;
                let index = $index
            ) {
                <mat-divider></mat-divider>
                <div class="start-center flex-row" style="padding: 10px 16px">
                    @if (canSelectLot(interest)) {
                        <cb-checkbox
                            class="cb-margin-right"
                            [name]="'selectedLotInterests' + index"
                            (change)="selectedLotsChanged($event, interest)"
                        >
                        </cb-checkbox>
                    }
                    @if (interest.isPrimary) {
                        <mat-icon title="Primary Lot Interest" class="mat-accent cb-margin-right"
                            >stars
                        </mat-icon>
                    }
                    @if (!interest.isPrimary) {
                        <mat-icon>radio_button_unchecked</mat-icon>
                    }
                    <div class="flex-col">
                        <span class="mat-body-strong"> Lot {{ interest.lot.lotNumber }} </span>
                        <span class="mat-body-2">
                            <span class="mat-body-strong">
                                {{ interest.lot.projectName }}
                            </span>
                            ,&nbsp;{{ interest.lot.address.city }}
                        </span>
                    </div>
                </div>
                <mat-divider></mat-divider>
            }
        </div>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="
                leadQualifyHouseLandForm.pristine ||
                leadQualifyHouseLandForm.invalid ||
                saveDisabled()
            "
            (cbClick)="save()"
            [clickLimit]="1"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
